// Multi-tenancy Phase 4b — single read point for environment values.
// Resolution order: window._env_ (public/env.js, overwritten per deployment)
// → build-time REACT_APP_* → fallback. Replaces scattered
// process.env.REACT_APP_* reads so one build serves every environment.
export const runtimeEnv = (key, fallback = '') => {
  const runtime = typeof window !== 'undefined' && window._env_ ? window._env_[key] : undefined;
  // eslint-disable-next-line no-undef -- CRA substitutes process.env at build time
  return runtime || process.env[`REACT_APP_${key}`] || fallback;
};
